import { download, getExcelTemplateName } from "src/utils/page";
import { useMemo } from "react";
import api, { useSWR } from "../utils/axios";

export const endpoint = "dynamic-configuration";

const baseUrl = `/api/${endpoint}/`;

export function getById(id, type) {
  return api.get(`${baseUrl}${type}/${id}`);
}

export function useGet(id) {
  const url = `${baseUrl}${id}`;

  const { data, isLoading, error, isValidating, mutate } = useSWR(id ? url : null);

  const memoizedValue = useMemo(
    () => ({
      dynamicConfigurations: data || [],
      isLoading,
      error,
      isValidating,
      mutate,
    }),
    [data, error, isLoading, isValidating, mutate]
  );

  return memoizedValue;
}

export function update(parameterId, request) {
  return api.put(`${baseUrl}update/${parameterId}`, {
    ...request,
  });
}

export async function downloadExcelTemplate() {
  const response = await api.get(`${baseUrl}download-excel-template/`, { responseType: "blob" });

  return download(response, getExcelTemplateName("additional-data"));
}
